module.exports = __webpack_public_path__ + "img/kukimide.6ae06006.webp";